import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/95 to-primary/90 text-primary-foreground overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-foreground/10 backdrop-blur-sm rounded-full border border-primary-foreground/20">
              <Icon name="Shield" size={20} />
              <span className="text-sm md:text-base font-medium">FIFA Compliant Operations</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline leading-tight">
              Regulatory Excellence in Football Transfers
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-primary-foreground/90 leading-relaxed">
              ProX11Market operates with unwavering commitment to FIFA regulations, international transfer standards, and ethical practices. Our comprehensive compliance framework ensures every transaction meets the highest regulatory standards.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3 px-4 md:px-6 py-3 md:py-4 bg-primary-foreground/10 backdrop-blur-sm rounded-lg border border-primary-foreground/20">
                <Icon name="CheckCircle2" size={24} className="text-success flex-shrink-0" />
                <div>
                  <div className="text-xl md:text-2xl font-bold">100%</div>
                  <div className="text-xs md:text-sm text-primary-foreground/80">FIFA Compliant</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3 px-4 md:px-6 py-3 md:py-4 bg-primary-foreground/10 backdrop-blur-sm rounded-lg border border-primary-foreground/20">
                <Icon name="Award" size={24} className="text-accent flex-shrink-0" />
                <div>
                  <div className="text-xl md:text-2xl font-bold">15+</div>
                  <div className="text-xs md:text-sm text-primary-foreground/80">Certifications</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3 px-4 md:px-6 py-3 md:py-4 bg-primary-foreground/10 backdrop-blur-sm rounded-lg border border-primary-foreground/20">
                <Icon name="Globe" size={24} className="text-secondary flex-shrink-0" />
                <div>
                  <div className="text-xl md:text-2xl font-bold">45+</div>
                  <div className="text-xs md:text-sm text-primary-foreground/80">Countries Covered</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-square bg-primary-foreground/10 backdrop-blur-sm rounded-2xl border border-primary-foreground/20 p-6 md:p-8 lg:p-10">
              <div className="h-full flex flex-col justify-center space-y-6 md:space-y-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-success/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="FileCheck" size={24} className="text-success" />
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold mb-2">FIFA RSTP Certified</h3>
                    <p className="text-sm md:text-base text-primary-foreground/80">Full compliance with Regulations on the Status and Transfer of Players</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-accent/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Scale" size={24} className="text-accent" />
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold mb-2">Legal Framework</h3>
                    <p className="text-sm md:text-base text-primary-foreground/80">Adherence to international labor laws and work permit regulations</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-secondary/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Lock" size={24} className="text-secondary" />
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold mb-2">Data Protection</h3>
                    <p className="text-sm md:text-base text-primary-foreground/80">GDPR compliant with secure handling of sensitive information</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;